import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
library.add(fab, fas, far);

const FieldDate = (props) => {
  let field = props.field;
  let element = props.element;

  const dateOrder = field.options && field.options["date-order"]
    ? field.options["date-order"]
    : "MM/DD/YYYY";

  const outputFormat = field.options && field.options["date-output-format"]
    ? field.options["date-output-format"]
    : "slash";

  const isDateTimeFormat = outputFormat === "datetime" || outputFormat === "datetime-tz";

  const getPlaceholder = () => {
    const separator = outputFormat === "dash" ? "-" : "/";
    let datePart = dateOrder.toLowerCase().replace(/\//g, separator);

    if (isDateTimeFormat) {
      return datePart + " hh:mm";
    }
    if (outputFormat === "timestamp") {
      return "timestamp";
    }
    return datePart;
  };

  const getDateFormat = () => {
    if (outputFormat === "datetime" || outputFormat === "datetime-tz" || outputFormat === "timestamp") {
      return outputFormat;
    }
    const separator = outputFormat === "dash" ? "-" : "/";
    return dateOrder.replace(/\//g, separator);
  };

  return (
    <React.Fragment>
      <div
        data-id={field.id}
        data-field={field.slug}
        data-pos={field.position ? field.position : ""}
        className="cf-form-field cf-custom-field"
        data-visible="true"
        data-multi-select=""
        style={{
          order: field.position,
        }}
      >
        <div
          id={"customfield" + field.id}
          data-required={field.required == true ? "true" : "false"}
          className={"contact-custom-field cf-text cf-col-xs-12"}
        >
          {field.label && props.hide_label !== true && (
            <label
              className="cf-label"
              style={{
                marginBottom: "4px",
                color: element.options["label-color"]
                  ? element.options["label-color"]
                  : "",
              }}
              htmlFor={"contact[extra][" + field.slug + "]"}
            >
              {field.label}
            </label>
          )}

          <div className="cf-date-input-wrapper" style={{ position: "relative" }}>
            <input
              name={"contact[extra][" + field.slug + "]"}
              id={"contact[extra][" + field.slug + "]"}
              type="text"
              readOnly
              defaultValue={field.value ? field.value : ""}
              placeholder={getPlaceholder()}
              style={{ marginBottom: "0px", cursor: "pointer" }}
              required={field.required == true}
              data-field-type="date"
              data-date-format={getDateFormat()}
              data-date-order={dateOrder}
              data-date-output-format={outputFormat}
              data-datetime={isDateTimeFormat ? "true" : "false"}
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

FieldDate.propTypes = {
  field: PropTypes.object.isRequired,
  element: PropTypes.object.isRequired,
  hide_label: PropTypes.bool,
};

export default FieldDate;
